import { type FC } from "react";

import { type MyLensesLens } from "../../gql-generated/types";
import { LensStatusWithWarning } from "../../lens/components/shared";
import { useLensDestinationTypesFromLens, useSubmissionErrors } from "../../lens/hooks";

interface BasicLensStatusProps {
    lens: MyLensesLens;
}

export const BasicLensStatus: FC<BasicLensStatusProps> = ({ lens }) => {
    const destinations = useLensDestinationTypesFromLens(lens);
    const { hasSubmissionErrors } = useSubmissionErrors(lens.id);

    return (
        <LensStatusWithWarning
            status={lens.status}
            destinations={destinations}
            showDestinationsText={false}
            loading={false}
            hasDistributionRestrictions={false}
            hasSubmissionErrors={hasSubmissionErrors}
        />
    );
};
